import { render } from "./HomeView.vue?vue&type=template&id=d54a48b0&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=d54a48b0&scoped=true&lang=css"

import exportComponent from "C:\\Fejlesztések\\JelentkezesiRendszer\\FrontEnd\\Eredeti\\jelentkezesirendszer_frontend_tabor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d54a48b0"]])

export default __exports__